import React, { useState, useEffect } from 'react';
import { OpticalRotationDatum } from '../models/optical-rotation-datum';
import OpticalRotationDataComponent from './OpticalRotationDataComponent'
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import DataGrid, {
    Column,
    Paging,
    Toolbar,
    Selection,
    Item as ToolbarItem
} from 'devextreme-react/data-grid';

import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';

let key = 0;

export interface Props {
    benchSheetId?: string;
    batchId?: string;
    isReadOnly: boolean;
    datagridHeight?: string;
    title?: string;
}

export default function OpticalRotationDataData(props: Props) {
    const [opticalRotationData, setOpticalRotationData] =
        useState<OpticalRotationDatum[]>();

    const [opticalRotationDataEditorVisible, setOpticalRotationDataEditorVisible] =
        useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, [props.benchSheetId]);

    key++;

    return (
        <div>
            <div className="pw-comp-row">
                <DataGrid id="OpticalRotationDataDataGrid"
                    height="16rem"
                    keyExpr="opticalRotationDatumId"
                    dataSource={opticalRotationData ? opticalRotationData : []}
                    rowAlternationEnabled={true}
                    showBorders={true}>

                    <Paging enabled={false} />
                    <Selection mode='single' />

                    <Column dataField='sampleName' dataType="string" width="10rem" />
                    <Column dataField='lotNumber' caption='Lot#' dataType="string" width="10rem" />
                    <Column dataField='weight' dataType="number" width="9rem" />
                    <Column dataField='correctedWeight' dataType="number" width="9rem" />
                    <Column dataField='concentration' dataType="number" width="9rem" />
                    <Column dataField='rotation' caption='Rotation(°)'  dataType="number" width="9rem" />

                    {/*
                    <Column dataField='angularRotation' caption='Angular Rotation(°)' dataType="number" width="10rem" />
                    */}

                    <Column />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Data Collected</div>
                            </div>
                        </ToolbarItem>

                        <ToolbarItem location="after">
                            <Button hint="Edit" icon="inserttable" disabled={props.isReadOnly}
                                    width="1.8rem" onClick={showOpticalRotationDataEditor} />
                        </ToolbarItem>
                                            
                    </Toolbar>
                </DataGrid>
            </div>

            {opticalRotationDataEditorVisible &&
                <DialogPopup
                    visible={opticalRotationDataEditorVisible}
                    onHiding={hideOpticalRotationDataEditor}
                    dragEnabled={false}
                    fullScreen={true}
                    hideOnOutsideClick={false}
                    title="Optical Rotation Data">
                    <OpticalRotationDataComponent key={`nmrs${key}`}
                        benchSheetId={props.benchSheetId}
                        onClose={onCloseOpticalRotationDataEditor} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    async function getOpticalRotationData(){
        await CrudFunctions.getData(`benchsheets/opticalrotationdata/${props.benchSheetId}`)
        .then(data => {
            setOpticalRotationData(data);
        })
        .catch((res) => {
            showMessage(res, ModalMessageType.Error, "Error Retrieving Bench Sheet Data");
        });
    }

    async function getAllData() {
        getOpticalRotationData();
    }

    function onCloseOpticalRotationDataEditor(){
        hideOpticalRotationDataEditor();
        getOpticalRotationData();
    }

    function showOpticalRotationDataEditor(){
        setOpticalRotationDataEditorVisible(true);
    }

    function hideOpticalRotationDataEditor(){
        setOpticalRotationDataEditorVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };
   
        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

}






